import { createSvgIcon } from "@mui/material";

const UnCheckboxIcon = createSvgIcon(
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_979_43582)">
      <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" fill="white" />
      <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="#DBDDE0" />
    </g>
    <defs>
      <clipPath id="clip0_979_43582">
        <rect width="20" height="20" rx="10" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  "UnCheckbox"
);

export default UnCheckboxIcon;
